import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

/**
 * FeatureCard — Ana sayfa hızlı-eylem kartı.
 * tone: "green" | "blue" | "yellow" | "red" | "black"
 * filled: içeriği tonun dolu haliyle (primary CTA gibi)
 */
export default function FeatureCard({
  tone = "green",
  filled = false,
  icon,
  title,
  subtitle,
  testId,
  onClick,
  right = <ArrowRight className="h-5 w-5" />,
}) {
  return (
    <motion.button
      type="button"
      onClick={onClick}
      data-testid={testId}
      whileHover={{ y: -2, scale: 1.01 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: "spring", stiffness: 400, damping: 24 }}
      className={`card-tone-${tone} tone-glow-shadow w-full h-16 rounded-2xl flex items-center justify-between px-4 border relative overflow-hidden ${
        filled
          ? "text-white [background:linear-gradient(135deg,hsl(var(--tone))_0%,hsl(var(--tone)/0.75)_100%)] tone-border"
          : "tone-bg tone-border text-foreground"
      }`}
    >
      {/* Ambient tile-corner motif */}
      <span
        aria-hidden
        className="absolute -right-4 -bottom-4 w-16 h-16 rounded-xl opacity-15"
        style={{ background: "hsl(var(--tone))" }}
      />
      <div className="flex items-center gap-3 relative z-10">
        <div
          className={`h-10 w-10 rounded-xl flex items-center justify-center ${
            filled ? "bg-white/25" : "tone-text"
          }`}
          style={!filled ? { backgroundColor: "hsl(var(--tone) / 0.15)" } : undefined}
        >
          {icon}
        </div>
        <div className="text-left">
          <div className={`font-display font-bold text-base ${filled ? "text-white" : ""}`}>
            {title}
          </div>
          <div className={`text-xs ${filled ? "text-white/80" : "text-muted-foreground"}`}>
            {subtitle}
          </div>
        </div>
      </div>
      <span className={`relative z-10 ${filled ? "text-white" : "tone-text opacity-70"}`}>
        {right}
      </span>
    </motion.button>
  );
}
